query PurchaseCardCommonData {
  companyBusinessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  documentPools(
    filter: {
      defaultDocumentTypes: { isReportingDocument: { equalTo: false } }
    }
    orderBy: NAME_ASC
  ) {
    nodes {
      id
      name
    }
  }
  companyDepartments(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyUserGroups(orderBy: USER_GROUP_BY_USER_GROUP_ID__NAME_ASC) {
    nodes {
      userGroupId
      userGroup {
        name
      }
    }
  }
  availableCardHolderUsers(orderBy: USER_NAME_ASC) {
    nodes {
      id
      userName
      departmentId
      userGroupId
    }
  }
}
